import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "text-3xl font-medium capitalize" }
const _hoisted_6 = {
  key: 0,
  class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded"
}
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "mx-2 my-2 text-sm" }
const _hoisted_9 = { class: "block capitalize" }
const _hoisted_10 = { class: "block capitalize" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = {
  key: 2,
  class: "relative flex mt-6 group"
}
const _hoisted_16 = { class: "absolute px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity bg-gray-800 rounded-md opacity-0 cursor-not-allowed -translate-y-1/3 w-fit bottom-4 group-hover:opacity-100" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = { class: "text-3xl font-medium capitalize" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = { class: "text-3xl font-medium capitalize" }
const _hoisted_29 = { class: "mr-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_18809_4626)" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white",
      "fill-opacity": "0.01"
    }),
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_18809_4626)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0.5 9.89921C0.632608 9.89921 0.759785 9.95189 0.853553 10.0457C0.947322 10.1394 1 10.2666 1 10.3992V12.8992C1 13.1644 1.10536 13.4188 1.29289 13.6063C1.48043 13.7938 1.73478 13.8992 2 13.8992H14C14.2652 13.8992 14.5196 13.7938 14.7071 13.6063C14.8946 13.4188 15 13.1644 15 12.8992V10.3992C15 10.2666 15.0527 10.1394 15.1464 10.0457C15.2402 9.95189 15.3674 9.89921 15.5 9.89921C15.6326 9.89921 15.7598 9.95189 15.8536 10.0457C15.9473 10.1394 16 10.2666 16 10.3992V12.8992C16 13.4296 15.7893 13.9383 15.4142 14.3134C15.0391 14.6885 14.5304 14.8992 14 14.8992H2C1.46957 14.8992 0.960859 14.6885 0.585786 14.3134C0.210714 13.9383 0 13.4296 0 12.8992V10.3992C0 10.2666 0.0526784 10.1394 0.146447 10.0457C0.240215 9.95189 0.367392 9.89921 0.5 9.89921Z",
        fill: "white"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.646 11.8532C7.69245 11.8998 7.74762 11.9367 7.80837 11.9619C7.86911 11.9871 7.93423 12.0001 8 12.0001C8.06577 12.0001 8.13089 11.9871 8.19163 11.9619C8.25238 11.9367 8.30755 11.8998 8.354 11.8532L11.354 8.85321C11.4479 8.75932 11.5006 8.63198 11.5006 8.49921C11.5006 8.36643 11.4479 8.23909 11.354 8.14521C11.2601 8.05132 11.1328 7.99857 11 7.99857C10.8672 7.99857 10.7399 8.05132 10.646 8.14521L8.5 10.2922V1.49921C8.5 1.3666 8.44732 1.23942 8.35355 1.14565C8.25979 1.05188 8.13261 0.999207 8 0.999207C7.86739 0.999207 7.74021 1.05188 7.64645 1.14565C7.55268 1.23942 7.5 1.3666 7.5 1.49921V10.2922L5.354 8.14521C5.26011 8.05132 5.13278 7.99857 5 7.99857C4.86722 7.99857 4.73989 8.05132 4.646 8.14521C4.55211 8.23909 4.49937 8.36643 4.49937 8.49921C4.49937 8.63198 4.55211 8.75932 4.646 8.85321L7.646 11.8532Z",
        fill: "white"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_34 = { class: "w-full mt-4 table-fixed" }
const _hoisted_35 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_36 = { class: "px-2 py-2" }
const _hoisted_37 = { class: "px-2 py-2 capitalize" }
const _hoisted_38 = { class: "px-2 py-2" }
const _hoisted_39 = { class: "px-2 py-6 md:py-3" }
const _hoisted_40 = { class: "px-2 py-6 md:py-3" }
const _hoisted_41 = { class: "px-2 py-6 md:py-3" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_45 = { class: "w-full mt-4 table-fixed" }
const _hoisted_46 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_47 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_48 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_49 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_50 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_51 = { class: "px-2 py-6 md:py-3" }
const _hoisted_52 = { class: "px-2 py-6 md:py-3" }
const _hoisted_53 = { class: "px-2 py-6 md:py-3" }
const _hoisted_54 = {
  key: 0,
  class: "px-2 py-6 space-x-4 md:py-3 whitespace-nowrap"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_59 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_60 = {
  key: 0,
  class: "w-full mt-4 table-fixed"
}
const _hoisted_61 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_62 = { class: "w-1/5 px-2 py-2" }
const _hoisted_63 = { class: "capitalize" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path transform=\"rotate(180, 9, 9)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "px-2 py-6 md:py-3" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_74 = {
  key: 0,
  class: "w-full mt-4 table-auto"
}
const _hoisted_75 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_76 = { class: "px-2 py-2 capitalize" }
const _hoisted_77 = { class: "px-2 py-2 capitalize" }
const _hoisted_78 = { class: "px-2 py-2" }
const _hoisted_79 = { class: "px-2 py-2" }
const _hoisted_80 = { class: "px-2 py-2" }
const _hoisted_81 = { class: "px-2 py-2" }
const _hoisted_82 = { class: "px-2 py-2" }
const _hoisted_83 = { class: "px-2 py-2" }
const _hoisted_84 = { class: "px-2 py-2" }
const _hoisted_85 = { class: "px-2 py-2" }
const _hoisted_86 = { class: "px-2 py-2" }
const _hoisted_87 = { class: "px-2 py-6 md:py-3" }
const _hoisted_88 = { class: "px-2 py-6 md:py-3" }
const _hoisted_89 = { class: "px-2 py-6 md:py-3" }
const _hoisted_90 = { class: "px-2 py-6 md:py-3" }
const _hoisted_91 = { class: "px-2 py-6 md:py-3" }
const _hoisted_92 = { class: "px-2 py-6 md:py-3" }
const _hoisted_93 = { class: "px-2 py-6 md:py-3" }
const _hoisted_94 = { class: "px-2 py-6 md:py-3" }
const _hoisted_95 = { class: "px-2 py-6 md:py-3" }
const _hoisted_96 = { class: "px-2 py-6 space-x-4 md:py-3 whitespace-nowrap" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 3 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "flex items-center justify-between" }
const _hoisted_104 = { class: "text-3xl font-medium capitalize" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { class: "flex items-center justify-between" }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "flex items-center justify-between" }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { key: 2 }
const _hoisted_112 = { class: "flex items-center justify-between" }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { key: 1 }

import { computed, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import AddGoalProgressModal from "@/components/modals/AddGoalProgressModal.vue";
import AddMemberGoalModal from "@/components/modals/AddMemberGoalModal.vue";
import GoalProgressChart from "@/components/charts/GoalProgressChart.vue";
import ArchiveGoalModal from "@/components/modals/ArchiveGoalModal.vue";
import StudentNoteModal from "@/components/modals/StudentNoteModal.vue";
import GoalNotesModal from "@/components/modals/GoalNotesModal.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";
import TabGroup from "@/components/TabGroup.vue";
import FeedbackTable from "@/components/tables/FeedbackTable.vue";
import RouterButton from "@/components/RouterButton.vue";

import api from "@/api/api";
import { formatDate } from "@/utils/dates";
import { useGlobalStore, useUserStore } from "@/store";
import { Club, Goal, Student, StudentNote, ClubDate } from "@/types";
import { userHasRole } from "@/utils/roles";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberOutcomePage',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const { user } = storeToRefs(useUserStore());
const route = useRoute();
const website_url = process.env.VUE_APP_WEBSITE_URL;

const isAddGoalProgressModalOpen = ref(false);
const isArchiveGoalModalOpen = ref(false);
const isMemberGoalModalOpen = ref(false);
const isGoalNotesModalOpen = ref(false);
const isNoteModalOpen = ref(false);
const isSavingNote = ref(false);
const isSavingGoal = ref(false);
const showGraph = ref(true);

const club = ref({} as Club);
const member = ref({} as Student);
const notes = ref([] as StudentNote[]);
const goals = ref([] as Goal[]);
const goalsActive = ref([] as Goal[]);
const goalsArchived = ref([] as Goal[]);

const progressDates = ref([] as ClubDate[]);

const goalModalMode = ref("create");
const selectedGoal = ref({} as Goal | null);

const noteModalMode = ref("create");
const selectedNote = ref({} as StudentNote | null);

const isDownloadingReport = ref(false);
const showSessionFeedbackButton = ref(false);
const sessionFeedbackUrl = ref("");
const surveyClubDate = ref("");
const hasSmartsurveyAccess = ref(false);
hasSmartsurveyAccess.value = user.value.has_smartsurvey_access;

if (hasSmartsurveyAccess.value === true) {
  (
  ([__temp,__restore] = _withAsyncContext(() => getMember())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => listMemberGoals())),
  await __temp,
  __restore()
);
}

const userIsParent = userHasRole(user.value.roles, ["parent"]) ? true : false;
const userIsFacilitator = userHasRole(user.value.roles, [
  "advanced-facilitator-trainee",
  "advanced-facilitator",
  "certified-facilitator-trainee",
  "certified-facilitator",
  "facilitator-organisation",
])
  ? true
  : false;

const SMARTSURVEY_EVAL_MEMBER_URL =
  process.env.VUE_APP_SMARTSURVEY_EVAL_MEMBER_URL + "?uId=" + user.value.id + "&mId=" + member.value.id + "&bcId=" + club.value.id + "&fId=" + club.value.facilitator_id;
const SMARTSURVEY_EVAL_PARENT_URL =
  process.env.VUE_APP_SMARTSURVEY_EVAL_PARENT_URL + "?uId=" + user.value.id + "&mId=" + member.value.id + "&bcId=" + club.value.id + "&fId=" + club.value.facilitator_id;
const SMARTSURVEY_EVAL_FACILITATOR_URL =
  process.env.VUE_APP_SMARTSURVEY_EVAL_FACILITATOR_URL + "?uId=" + user.value.id + "&mId=" + member.value.id + "&bcId=" + club.value.id + "&fId=" + club.value.facilitator_id;

const memberFeedbackSurveyData = ref([]);

const goalsTablePage = ref(0);
const facilitatorEvalIsDue = ref(false);
const parentEvalIsDue = ref(false);
const memberEvalIsDue = ref(false);

const goalsTableDatePaginated = computed(() => {
  const page = goalsTablePage.value;
  return club.value.dates.slice(page * 5, (page + 1) * 5);
});

const goalsTablePagesLast = computed(() => {
  return Math.ceil(club.value.dates.length / 5) - 1;
});

/** Tabs Refs */
const tabs = ref([
  {
    id: "member_notes",
    name: "member-notes",
  },
  {
    id: "member_session_feedback",
    name: "member-session-feedback",
  },
  {
    id: "goal_tracking",
    name: "goal-tracking",
  },
  {
    id: "evaluation",
    name: "evaluation",
  },
]);
const selectedTab = ref("member_notes");
let activeTab = "member_notes";

const GoalTrackingTabs = ref([
  {
    id: "summary",
    name: "summary",
  },
  {
    id: "goal_tracking",
    name: "goal-tracking",
  },
  {
    id: "archived_goals",
    name: "archived-goals",
  },
]);
const selectedGoalTrackingTab = ref("summary");

const GraphTableTabs = ref([
  {
    id: "graph",
    name: "graph",
  },
  {
    id: "table",
    name: "table",
  },
]);
const selectedGraphTableTab = ref(GraphTableTabs.value[0].id);

const ProgressTabs = ref([
  {
    id: "member_views",
    name: "Member Views",
  },
  {
    id: "parent_views",
    name: "Parent Views",
  },
  {
    id: "facilitator_views",
    name: "Facilitator Views",
  },
]);
const selectedProgressTab = ref(ProgressTabs.value[0].id);

async function getMember() {
  let response;

  if (userHasRole(user.value.roles, ["admin"])) {
    response = (await api.students.getMember(route.params.member_id as string)).data;
  } else if (userHasRole(user.value.roles, ["facilitator-organisation"])) {
    response = (await api.students.getMemberByOrganisation(route.params.member_id as string)).data;
  } else {
    response = (await api.students.getMemberByFacilitator(user.value.id, route.params.member_id as string)).data;
  }

  member.value = response.member;
  notes.value = response.notes;
  club.value = response.member.clubs[0];
}

/** Member Notes */
function openNoteModal(mode: string, note?: StudentNote) {
  noteModalMode.value = mode;

  if (mode === "update") {
    selectedNote.value = note!;
  }

  if (mode === "create") {
    selectedNote.value = null;
  }

  isNoteModalOpen.value = true;
}

async function createStudentNote(brick_club_date_id: number, content: string, show_parent: boolean) {
  try {
    isSavingNote.value = true;
    await api.students.createStudentNote(club.value.id, member.value.id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
      show_parent: show_parent,
      student_id: member.value.id,
    });

    globalStore.toast("SUCCESS", "Note created");

    await getMember();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error adding Note");
  } finally {
    isSavingNote.value = false;
  }
}

async function editStudentNote(id: StudentNote["id"], brick_club_date_id: number, content: string, show_parent: boolean) {
  try {
    isSavingNote.value = true;
    await api.students.updateStudentNote(club.value.id, member.value.id, id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
      show_parent: show_parent,
      student_id: member.value.id,
    });

    globalStore.toast("SUCCESS", "Note updated");

    await getMember();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error updating Note");
  } finally {
    isSavingNote.value = false;
  }
}

/** Member Goals */
async function openAddGoalProgressModal(goal: Goal) {
  selectedGoal.value = goal;
  isAddGoalProgressModalOpen.value = true;
  await getMissingGoalProgressDates();
}

function openMemberGoalModal(mode: string, goal?: Goal) {
  goalModalMode.value = mode;

  if (mode === "update") {
    selectedGoal.value = goal!;
  }

  if (mode === "create") {
    selectedGoal.value = {} as Goal;
  }

  isMemberGoalModalOpen.value = true;
}

async function openArchiveGoalModal(goal: Goal) {
  selectedGoal.value = goal;
  isArchiveGoalModalOpen.value = true;
}

async function openGoalNotesModal(goal: Goal) {
  selectedGoal.value = goal;
  isGoalNotesModalOpen.value = true;
}

async function listMemberGoalsAll() {
  showGraph.value = false;
  listMemberGoals();
  listMemberGoalsArchived();
}

async function listMemberGoals() {
  if (isMemberGoalModalOpen.value) {
    isMemberGoalModalOpen.value = false;
  }

  if (isArchiveGoalModalOpen.value) {
    isArchiveGoalModalOpen.value = false;
  }

  if (isAddGoalProgressModalOpen.value) {
    isAddGoalProgressModalOpen.value = false;
  }

  const response = (await api.goals.listMemberGoalsByClub(club.value.id, member.value.id)).data;
  goals.value = response.goals;
  goalsActive.value = response.goals.filter((goal: Goal) => goal.status === "active");
  showGraph.value = true;
}
async function listMemberGoalsArchived() {
  if (isMemberGoalModalOpen.value) {
    isMemberGoalModalOpen.value = false;
  }

  if (isArchiveGoalModalOpen.value) {
    isArchiveGoalModalOpen.value = false;
  }

  if (isAddGoalProgressModalOpen.value) {
    isAddGoalProgressModalOpen.value = false;
  }

  const response = (await api.goals.listMemberArchivedGoalsByClub(club.value.id, member.value.id)).data;
  goalsArchived.value = response.goals;
}

async function getMemberSurveyResults() {
  const id = member.value.id;
  const response = await api.surveys.getMemberSurveyResults(id);
  memberFeedbackSurveyData.value = response.data?.memberSurveryResults?.survey_groups;
}

async function getChildGoalReport() {
  isDownloadingReport.value = true;
  const reportUrl = await api.goals.generateChildGoalReport(club.value.id, member.value.id);
  if (reportUrl) {
    isDownloadingReport.value = false;
    window.open(reportUrl.data.report, "_blank");
  }
}

async function getMemberSessionFeedbackUrl() {
  const currentSessionFeedbackUrl = showSessionFeedbackButton.value ? sessionFeedbackUrl.value : "";
  if (!currentSessionFeedbackUrl.length) showSessionFeedbackButton.value = false;
  const sessionFeedback = await api.surveys.getMemberSessionFeedbackUrl(club.value.id, member.value.id);
  if (sessionFeedback.data.sessionFeedbackDue && club.value.user_id === user.value.id) {
    if (currentSessionFeedbackUrl !== sessionFeedback.data.session_feedback_url) {
      showSessionFeedbackButton.value = false;
    }
    showSessionFeedbackButton.value = true;
    sessionFeedbackUrl.value = sessionFeedback.data.session_feedback_url;
    if (sessionFeedback.data.survey_club_date) {
      const date = new Date(sessionFeedback.data.survey_club_date.date);
      surveyClubDate.value = formatDate(date);
    }
  }
}

async function getLatestEvalationDatesForClubAndStudent() {
  const feedbackDueDates = await api.surveys.getLatestEvalationDatesForClubAndStudent(club.value.id, member.value.id);

  if (!feedbackDueDates) {
    console.log("No feedback due dates found");
    return;
  }

  if (feedbackDueDates.data) {
    facilitatorEvalIsDue.value = feedbackDueDates.data.facilitator_eval_due;
    parentEvalIsDue.value = feedbackDueDates.data.parent_eval_due;
    memberEvalIsDue.value = feedbackDueDates.data.student_eval_due;
  }
}

async function getMissingGoalProgressDates() {
  console.log("Getting missing goal progress dates");
  if (selectedGoal.value && selectedGoal.value.id) {
    console.log("Selected goal exists:", selectedGoal.value.id);
  } else {
    console.log("No goal is selected.");
    return;
  }
  const response = await api.surveys.getMissingGoalProgressDates(club.value.id, member.value.id, selectedGoal.value.id);
  console.log("Missing goal progress dates", JSON.stringify(response.data.missingDates));
  progressDates.value = response.data.missingDates;
  // club.value.dates = response.data.dates;
}

if (hasSmartsurveyAccess.value === true) {
  (
  ([__temp,__restore] = _withAsyncContext(() => getMember())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => listMemberGoals())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => listMemberGoalsArchived())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => getMemberSessionFeedbackUrl())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => getLatestEvalationDatesForClubAndStudent())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => getMemberSurveyResults())),
  await __temp,
  __restore()
);
}

onMounted(() => {
  selectedTab.value = route.query.tab ? (route.query.tab as string) : "member_notes";

  if (member.value.survey_permission) {
    setInterval(async () => {
      if (hasSmartsurveyAccess.value === true) {
        //Only call the following if the current tab on the page is evaluation
        if (activeTab === "evaluation") {
          console.log("Polling for evaluation due dates");
          await getLatestEvalationDatesForClubAndStudent();
          await getMemberSurveyResults();
        }

        if (activeTab === "member_session_feedback") {
          console.log("Polling for session feedback");
          await getMemberSurveyResults();
          await getMemberSessionFeedbackUrl();
        }
      }
    }, 10000);
  }
});

// Watch for changes to the selectedTab and log the current tab to the console
watch(selectedTab, async newTab => {
  console.log("active tab:", newTab);
  activeTab = newTab;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StudentNoteModal, {
      isOpen: isNoteModalOpen.value,
      mode: noteModalMode.value,
      note: selectedNote.value,
      dates: club.value.dates ? club.value.dates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) : [],
      isSavingNote: isSavingNote.value,
      onCreate: createStudentNote,
      onUpdate: editStudentNote,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isNoteModalOpen.value = false))
    }, null, 8, ["isOpen", "mode", "note", "dates", "isSavingNote"]),
    _createVNode(AddMemberGoalModal, {
      isOpen: isMemberGoalModalOpen.value,
      isSavingGoal: isSavingGoal.value,
      mode: goalModalMode.value,
      club_id: club.value.id,
      member_id: member.value.id,
      goal: selectedGoal.value,
      onFetch: listMemberGoalsAll,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isMemberGoalModalOpen.value = false))
    }, null, 8, ["isOpen", "isSavingGoal", "mode", "club_id", "member_id", "goal"]),
    _createVNode(AddGoalProgressModal, {
      isOpen: isAddGoalProgressModalOpen.value,
      isSavingGoalProgress: isSavingGoal.value,
      club_id: club.value.id,
      member_id: member.value.id,
      goal: selectedGoal.value,
      dates: progressDates.value,
      onFetch: listMemberGoalsAll,
      onRequestMissingDates: getMissingGoalProgressDates,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isAddGoalProgressModalOpen.value = false))
    }, null, 8, ["isOpen", "isSavingGoalProgress", "club_id", "member_id", "goal", "dates"]),
    _createVNode(ArchiveGoalModal, {
      isOpen: isArchiveGoalModalOpen.value,
      isSavingGoal: isSavingGoal.value,
      club_id: club.value.id,
      member_id: member.value.id,
      goal: selectedGoal.value,
      onFetch: listMemberGoalsAll,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isArchiveGoalModalOpen.value = false))
    }, null, 8, ["isOpen", "isSavingGoal", "club_id", "member_id", "goal"]),
    _createVNode(GoalNotesModal, {
      isOpen: isGoalNotesModalOpen.value,
      goal: selectedGoal.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isGoalNotesModalOpen.value = false))
    }, null, 8, ["isOpen", "goal"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: `${member.value.first_name}${member.value.middle_name ? ' ' + member.value.middle_name : ''} ${member.value.last_name}`
      }, null, 8, ["title"]),
      _createVNode(RouterButton, {
        type: "primary",
        to: { path: `/dashboard/clubs/${club.value.id}`, query: { tab: `member_progress` } }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("back-to-manage-brick-club")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabGroup, {
        tabs: tabs.value,
        "selected-tab": selectedTab.value,
        onSelect: _cache[5] || (_cache[5] = e => (selectedTab.value = e))
      }, null, 8, ["tabs", "selected-tab"]),
      (selectedTab.value === 'member_notes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("brick-club-notes")), 1)
            ]),
            (notes.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex flex-wrap justify-between w-full px-4 py-2 md:flex-nowrap",
                      key: note.id
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("facilitator")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(note.user.first_name) + " " + _toDisplayString(note.user.last_name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_10, [
                            (note.session.brick_club)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(_ctx.$t("brick-club")) + ":", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(note.session.brick_club?.name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_12, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("session")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(new Date(note.session.date).toLocaleDateString()), 1)
                          ]),
                          _createElementVNode("span", _hoisted_13, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("visible-to-member-parent-carer")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(note.show_parent ? "Yes" : "No"), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("created")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(new Date(note.created_at).toLocaleString()), 1)
                          ])
                        ]),
                        _hoisted_14,
                        _createVNode(ReadOnlyNote, {
                          content: note.content
                        }, null, 8, ["content"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(user).id === club.value.facilitator_id && member.value.survey_permission)
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 1,
                  class: "mt-6",
                  type: "primary",
                  onAction: _cache[6] || (_cache[6] = ($event: any) => (openNoteModal('create')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("add-a-member-note")), 1)
                  ]),
                  _: 1
                }))
              : (_unref(user).id === club.value.facilitator_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      class: "cursor-not-allowed",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("add-a-member-note")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("parent-consent-button")), 1)
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'member_session_feedback')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (member.value.survey_permission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t("member-session-feedback")), 1)
                  ]),
                  (showSessionFeedbackButton.value)
                    ? (_openBlock(), _createBlock(ExternalLink, {
                        key: 0,
                        type: "button",
                        href: sessionFeedbackUrl.value,
                        label: _ctx.$t('add-member-session-feedback')
                      }, null, 8, ["href", "label"]))
                    : _createCommentVNode("", true),
                  (showSessionFeedbackButton.value)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_21, _toDisplayString(_ctx.$t("for-session-held")) + " " + _toDisplayString(surveyClubDate.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("member-session-feedback-helptext-facilitator")) + " ", 1),
                    _createElementVNode("a", {
                      href: `/dashboard/clubs/${club.value.id}/participants/${member.value.id}`,
                      class: "underline text-blue",
                      target: "_blank"
                    }, _toDisplayString(_ctx.$t("here")), 9, _hoisted_22),
                    _createTextVNode(". ")
                  ]),
                  (memberFeedbackSurveyData.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t("arrow-keys-helptext")) + " " + _toDisplayString(_ctx.$t("after-adding-feedback-refresh")), 1))
                    : _createCommentVNode("", true),
                  (memberFeedbackSurveyData.value.length)
                    ? (_openBlock(), _createBlock(FeedbackTable, {
                        key: 3,
                        type: "session",
                        surveyData: memberFeedbackSurveyData.value
                      }, null, 8, ["surveyData"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-consent-button")), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'goal_tracking')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (member.value.survey_permission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("goal-tracking")), 1),
                    _createVNode(DefaultButton, {
                      class: "mt-6",
                      type: "primary",
                      onAction: getChildGoalReport,
                      loading: isDownloadingReport.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("download-report")), 1),
                        _hoisted_30
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _createVNode(TabGroup, {
                    tabs: GoalTrackingTabs.value,
                    "selected-tab": selectedGoalTrackingTab.value,
                    onSelect: _cache[7] || (_cache[7] = e => (selectedGoalTrackingTab.value = e))
                  }, null, 8, ["tabs", "selected-tab"]),
                  (selectedGoalTrackingTab.value === 'summary')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("goal-tracking-helptext-facilitator")), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goal-tracking-helptext-facilitator-2")), 1),
                          _createElementVNode("a", {
                            href: _unref(website_url) + '/howto',
                            target: "_blank",
                            class: "text-blue-500 underline hover:text-blue-600"
                          }, _toDisplayString(_ctx.$t("click-here")), 9, _hoisted_32),
                          _createTextVNode(". ")
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_33, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("table", _hoisted_34, [
                          _createElementVNode("thead", _hoisted_35, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("date-goal-set")), 1),
                              _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t("goal")), 1),
                              _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t("category")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "border-b border-gray-400",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_39, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                _createElementVNode("td", _hoisted_40, _toDisplayString(goal.description), 1),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(capitalize)(goal.category)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedGoalTrackingTab.value === 'goal_tracking')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("goal-tracking-helptext-facilitator")), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goal-tracking-helptext-facilitator-2")), 1),
                          _createElementVNode("a", {
                            href: _unref(website_url) + '/howto',
                            target: "_blank",
                            class: "text-blue-500 underline hover:text-blue-600"
                          }, _toDisplayString(_ctx.$t("click-here")), 9, _hoisted_43),
                          _createTextVNode(". ")
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_44, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("table", _hoisted_45, [
                          _createElementVNode("thead", _hoisted_46, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t("date-goal-set")), 1),
                              _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("goal")), 1),
                              _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$t("category")), 1),
                              _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("actions")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "border-b border-gray-400",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_51, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                _createElementVNode("td", _hoisted_52, _toDisplayString(goal.description), 1),
                                _createElementVNode("td", _hoisted_53, _toDisplayString(_unref(capitalize)(goal.category)), 1),
                                (_unref(user).id === club.value.facilitator_id)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                                      _createElementVNode("button", {
                                        class: "text-blue-500",
                                        onClick: ($event: any) => (openAddGoalProgressModal(goal))
                                      }, "Add progress", 8, _hoisted_55),
                                      _createElementVNode("button", {
                                        class: "text-blue-500",
                                        onClick: ($event: any) => (openMemberGoalModal('update', goal))
                                      }, "Edit", 8, _hoisted_56),
                                      _createElementVNode("button", {
                                        class: "text-red-500",
                                        onClick: ($event: any) => (openArchiveGoalModal(goal))
                                      }, "Archive", 8, _hoisted_57)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]),
                        (goals.value.filter(i => i.status === 'active').length > 2)
                          ? (_openBlock(), _createBlock(AlertCard, {
                              key: 0,
                              class: "mt-6",
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("goal-tracking-max")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(user).id === club.value.facilitator_id)
                          ? (_openBlock(), _createBlock(DefaultButton, {
                              key: 1,
                              class: "mt-6",
                              type: "primary",
                              disabled: goals.value.filter(i => i.status === 'active').length > 2,
                              onAction: _cache[8] || (_cache[8] = ($event: any) => (openMemberGoalModal('create')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("add-a-member-goal")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-description")), 1),
                        _createVNode(TabGroup, {
                          tabs: GraphTableTabs.value,
                          "selected-tab": selectedGraphTableTab.value,
                          onSelect: _cache[9] || (_cache[9] = e => (selectedGraphTableTab.value = e))
                        }, null, 8, ["tabs", "selected-tab"]),
                        (selectedGraphTableTab.value === 'graph')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              (showGraph.value && goalsActive.value.length)
                                ? (_openBlock(), _createBlock(GoalProgressChart, {
                                    key: 0,
                                    goals: goalsActive.value
                                  }, null, 8, ["goals"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (selectedGraphTableTab.value === 'table')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              (goals.value.filter(i => i.status === 'active').length)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_60, [
                                    _createElementVNode("thead", _hoisted_61, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_62, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["justify-between", { flex: goalsTablePage.value }])
                                          }, [
                                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("goal")), 1),
                                            (goalsTablePage.value)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (goalsTablePage.value--))
                                                }, _hoisted_65))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalsTableDatePaginated), (date, index) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            key: index,
                                            class: "px-2 py-2"
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["justify-between", { flex: index == _unref(goalsTableDatePaginated).length - 1 && goalsTablePage.value !== _unref(goalsTablePagesLast) }])
                                            }, [
                                              _createElementVNode("div", null, _toDisplayString(_unref(formatDate)(new Date(date!.date))), 1),
                                              (index == _unref(goalsTableDatePaginated).length - 1 && goalsTablePage.value !== _unref(goalsTablePagesLast))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (goalsTablePage.value++))
                                                  }, _hoisted_67))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          class: "border-b border-gray-400",
                                          key: index
                                        }, [
                                          _createElementVNode("td", _hoisted_68, _toDisplayString(goal.description), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalsTableDatePaginated), (date, index) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              class: "px-2 py-6 md:py-3 whitespace-nowrap",
                                              key: index
                                            }, [
                                              (goal.progress.find(i => i.date.date === date.date))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(goal.progress.find(i => i.date.date === date.date).progress), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_70, "-"))
                                            ]))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("no-active-goals")), 1)
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedGoalTrackingTab.value === 'archived_goals')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("archived-goals-helptext")), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("goal-tracking-score-helptext")), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_73, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-description")), 1),
                        (goalsArchived.value.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_74, [
                              _createElementVNode("thead", _hoisted_75, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_76, _toDisplayString(_ctx.$t("goal")), 1),
                                  _createElementVNode("th", _hoisted_77, _toDisplayString(_ctx.$t("categories")), 1),
                                  _createElementVNode("th", _hoisted_78, _toDisplayString(_ctx.$t("start-date")), 1),
                                  _createElementVNode("th", _hoisted_79, _toDisplayString(_ctx.$t("end-date")), 1),
                                  _createElementVNode("th", _hoisted_80, _toDisplayString(_ctx.$t("achieved")), 1),
                                  _createElementVNode("th", _hoisted_81, _toDisplayString(_ctx.$t("start-score")), 1),
                                  _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.$t("end-goal")), 1),
                                  _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.$t("steps-travelled")), 1),
                                  _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.$t("sessions")), 1),
                                  _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.$t("notes")), 1),
                                  _createElementVNode("th", _hoisted_86, _toDisplayString(_ctx.$t("meaningful-progress")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalsArchived.value, (goal, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "border-b border-gray-400",
                                    key: index
                                  }, [
                                    _createElementVNode("td", _hoisted_87, _toDisplayString(goal.description), 1),
                                    _createElementVNode("td", _hoisted_88, _toDisplayString(_unref(capitalize)(goal.category)), 1),
                                    _createElementVNode("td", _hoisted_89, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                    _createElementVNode("td", _hoisted_90, _toDisplayString(new Date(goal.end_date).toDateString()), 1),
                                    _createElementVNode("td", _hoisted_91, _toDisplayString(goal.achieved ? "Yes" : "No"), 1),
                                    _createElementVNode("td", _hoisted_92, _toDisplayString(goal.start_score), 1),
                                    _createElementVNode("td", _hoisted_93, _toDisplayString(goal.end_score), 1),
                                    _createElementVNode("td", _hoisted_94, _toDisplayString(goal.steps_travelled), 1),
                                    _createElementVNode("td", _hoisted_95, _toDisplayString(goal.sessions), 1),
                                    _createElementVNode("td", _hoisted_96, [
                                      (goal.notes)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "text-blue-500",
                                            onClick: ($event: any) => (openGoalNotesModal(goal))
                                          }, "View", 8, _hoisted_97))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_98, _toDisplayString(goal.meaningfull_progress), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("no-archived-goals")), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.$t("parent-consent-button")), 1))
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'evaluation')
        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
            (member.value.survey_permission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("h2", _hoisted_104, _toDisplayString(_ctx.$t("evaluation")), 1)
                  ]),
                  _createVNode(TabGroup, {
                    tabs: ProgressTabs.value,
                    "selected-tab": selectedProgressTab.value,
                    onSelect: _cache[12] || (_cache[12] = e => (selectedProgressTab.value = e))
                  }, null, 8, ["tabs", "selected-tab"]),
                  (selectedProgressTab.value === 'member_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                        (_unref(userIsFacilitator) && memberEvalIsDue.value)
                          ? (_openBlock(), _createBlock(AlertCard, {
                              key: 0,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("evaluation-nudge-banner-child")), 1),
                                  _createVNode(ExternalLink, {
                                    type: "button",
                                    href: SMARTSURVEY_EVAL_MEMBER_URL,
                                    label: _ctx.$t('complete-survey')
                                  }, null, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("evaluation-helptext")), 1),
                        (memberFeedbackSurveyData.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "student",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedProgressTab.value === 'parent_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        (_unref(userIsParent) && parentEvalIsDue.value)
                          ? (_openBlock(), _createBlock(AlertCard, {
                              key: 0,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("evaluation-nudge-banner")), 1),
                                  _createVNode(ExternalLink, {
                                    type: "button",
                                    href: SMARTSURVEY_EVAL_PARENT_URL,
                                    label: _ctx.$t('complete-survey')
                                  }, null, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("evaluation-helptext")), 1),
                        (memberFeedbackSurveyData.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_110, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "parent",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedProgressTab.value === 'facilitator_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        (_unref(userIsFacilitator) && facilitatorEvalIsDue.value)
                          ? (_openBlock(), _createBlock(AlertCard, {
                              key: 0,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_112, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("evaluation-nudge-banner")), 1),
                                  _createVNode(ExternalLink, {
                                    type: "button",
                                    href: SMARTSURVEY_EVAL_FACILITATOR_URL,
                                    label: _ctx.$t('complete-survey')
                                  }, null, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("evaluation-helptext")), 1),
                        (memberFeedbackSurveyData.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "facilitator",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.$t("parent-consent-button")), 1))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})